/**
 * Does an enrollment on this ticket have to pass the event's required tests?
 *
 * One computed rule (spec D5, R1), never stored:
 *   – a ticket that cannot yield a certificate never sees a test (the test
 *     exists only to earn the certificate; the 2026 free-stream incident
 *     was participants passing a test they could never be certified for);
 *   – a ticket bound to a speaker-type template never needs one (speakers
 *     earn the certificate by speaking).
 * A missing ticket (legacy free enrollment) keeps today's behaviour: tests
 * apply.
 */
export interface TicketTestGate {
  allow_certificate: boolean | null | undefined;
  templateType: 'participant' | 'speaker' | null | undefined;
}

/**
 * Why an enrollment does or does not get the event's tests:
 *   – 'included': the ticket needs them;
 *   – 'speaker': a speaker ticket, certified without a test (never told
 *     anything about tests);
 *   – 'not_included': the ticket yields no certificate, so the participant is
 *     told the test exists but is not part of their ticket.
 */
export type TicketTestAccess = 'included' | 'speaker' | 'not_included';

export function ticketTestAccess(ticket: TicketTestGate | null | undefined): TicketTestAccess {
  if (!ticket) return 'included';
  if (ticket.allow_certificate === false) return 'not_included';
  return ticket.templateType === 'speaker' ? 'speaker' : 'included';
}

export function ticketRequiresTest(ticket: TicketTestGate | null | undefined): boolean {
  return ticketTestAccess(ticket) === 'included';
}
